import { getFileTypeIconNameFromExtension } from "@/lib/files";

export default function FileIcon({ className, extension }) {
  return <img className={className} src={`/images/file-icons/${getFileTypeIconNameFromExtension(extension)}.svg`} />;
}
